import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getTest } from './abTestModule';
import useABTestActions from './useABTestActions';
import { useAdminTools } from '@techstyle/react-admin';
export default function useABTest(campaignCode) {
  var inParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var actions = useABTestActions();

  var _useAdminTools = useAdminTools(),
      isAdmin = _useAdminTools.enabled;

  var testData = useSelector(state => campaignCode ? getTest(state, campaignCode) : null);
  useEffect(() => {
    if (campaignCode) {
      actions.splitTest(campaignCode, _objectSpread(_objectSpread({}, inParams), {}, {
        explain: isAdmin
      }));
    }
  });
  return testData;
}